import { render } from "./dashboard.html?vue&type=template&id=0d688a8e&ts=true"
import script from "./dashboard.ts?vue&type=script&lang=ts"
export * from "./dashboard.ts?vue&type=script&lang=ts"

import "./dashboard.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__